/* VH Learn pages: shared video modal + side drawer. PRESENTATION ONLY: no cart, customer or network calls.
   Declarative and delegated, so it needs no globals and is safe to include from several sections:
     <a href="video.mp4" data-vh-video data-caption="...">   opens the video in a modal (JS off: the link opens the file)
     <a href="#drawer-id" data-vh-drawer>                     opens <div class="vh-learn-drawer" id="drawer-id"> (JS off: :target)
     [data-vh-close] inside a drawer closes it; so do Escape and a click on the backdrop. */
(function () {
  var html = document.documentElement;
  if (html.getAttribute('data-vh-learn') === '1') return;
  html.setAttribute('data-vh-learn', '1');
  html.classList.add('vh-learn-js');

  var layer = null, modal = null, vid = null, cap = null, from = null, drawer = null;
  function ensureModal() {
    if (modal) return;
    layer = document.createElement('div');
    layer.className = 'vh-page vh-learn vh-learn-layer';
    layer.innerHTML = '<div class="vh-learn-modal" role="dialog" aria-modal="true" aria-label="' + ((window.VH_I18N && window.VH_I18N.video) || 'Video') + '" hidden><div class="vh-learn-mbox">' +
      '<button type="button" class="vh-learn-x" data-vh-mclose>' + ((window.VH_I18N && window.VH_I18N.close) || 'Close') + '</button><video controls playsinline></video><span class="vh-learn-mcap"></span></div></div>';
    document.body.appendChild(layer);
    modal = layer.querySelector('.vh-learn-modal'); vid = modal.querySelector('video'); cap = modal.querySelector('.vh-learn-mcap');
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-vh-mclose]')) closeModal(); });
  }
  function openModal(src, caption) {
    ensureModal(); from = document.activeElement;
    vid.src = src; cap.textContent = caption || ''; modal.hidden = false; html.classList.add('vh-learn-lock');
    var p = vid.play(); if (p && p.catch) p.catch(function () {});
    modal.querySelector('[data-vh-mclose]').focus();
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    vid.pause(); vid.removeAttribute('src'); vid.load(); modal.hidden = true; html.classList.remove('vh-learn-lock');
    if (from && from.focus) from.focus();
  }
  function openDrawer(el, opener) {
    drawer = el; from = opener || document.activeElement;
    el.classList.add('is-open'); html.classList.add('vh-learn-lock');
    /* the theme's desktop smooth scroll (window.lenis, assets/engine.js) takes every wheel event: let the drawer scroll
       natively (data-lenis-prevent) and pause the page behind it */
    el.setAttribute('data-lenis-prevent', '');
    if (window.lenis && typeof window.lenis.stop === 'function') window.lenis.stop();
    var c = el.querySelector('[data-vh-close]'); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); html.classList.remove('vh-learn-lock'); drawer = null;
    if (window.lenis && typeof window.lenis.start === 'function') window.lenis.start();
    if (location.hash && document.getElementById(location.hash.slice(1)) && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    if (from && from.focus) from.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var v = t.closest && t.closest('.vh-learn [data-vh-video]');
    if (v) { var src = v.getAttribute('data-src') || v.getAttribute('href'); if (src) { e.preventDefault(); openModal(src, v.getAttribute('data-caption')); } return; }
    var d = t.closest && t.closest('.vh-learn [data-vh-drawer]');
    if (d) { var el = document.getElementById((d.getAttribute('href') || '').replace('#', '') || d.getAttribute('data-vh-drawer')); if (el) { e.preventDefault(); openDrawer(el, d); } return; }
    if (drawer && (t.closest('[data-vh-close]') || t === drawer)) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (modal && !modal.hidden) closeModal(); else if (drawer) closeDrawer();
  });
  /* a drawer opened through the URL hash (JS on, e.g. a shared link) gets the same focus + lock handling */
  function fromHash() {
    var el = location.hash && document.getElementById(location.hash.slice(1));
    if (el && el.classList.contains('vh-learn-drawer') && el !== drawer) openDrawer(el);
  }
  window.addEventListener('hashchange', fromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash); else fromHash();
})();
